import {get} from "@/utils/http"

export const _getList = params => get("/loginLog/selectPages", params);
